import { ClipTag } from "components/Evaluation/Stores/EvalStore";
import { sentimentToColor } from "components/Evaluation/Utils";
import { makeObservable, observable, runInAction } from "mobx";
import { AnswerTypeNames } from "models/AnswerType";
import LicensedModule from "models/LicensedModule";
import Question from "models/Question";
import { Tag } from "models/Tag";

export class ConvoModuleUIModel {
    @observable questionTags: Map<string, Tag[]> = new Map<string, Tag[]>();
    @observable moduleTypeName: string;
    @observable licensedModule: LicensedModule;

    conversationModuleId?: string;

    constructor(
        questions: Question[],
        module: LicensedModule,
        clipTags: ClipTag[],
        conversationModuleId?: string,
    ) {
        makeObservable(this);
        this.initializeNew(module, questions, clipTags, conversationModuleId);
    }

    private async initializeNew(
        module: LicensedModule,
        questions: Question[],
        clipTags: ClipTag[],
        conversationModuleId?: string,
    ) {
        this.moduleTypeName = module.name!;
        this.licensedModule = module;
        this.conversationModuleId = conversationModuleId;

        const sortedQuestions = questions.sort((a, b) => a.order - b.order);

        for (const question of sortedQuestions) {
            const valueTags: Tag[] = [];

            const names = question.tags.filter(
                (value) => value.isActive && question.isActive,
            );

            names
                .sort((a, b) => {
                    return a.order - b.order;
                })

                .forEach(
                    (value) =>
                        (value.parent = {
                            value: question.questionText,
                        } as Tag),
                );

            valueTags.push(...names);

            if (
                question.answerType.answerTypeName ===
                AnswerTypeNames.StarRating
            ) {
                valueTags.sort(
                    (a, b) => (a.scoredValue ?? 0) - (b.scoredValue ?? 0),
                );
            }

            runInAction(() => {
                this.questionTags.set(question.id, valueTags);
                if (
                    question.answerType.answerTypeName !==
                    AnswerTypeNames.StarRating
                ) {
                    clipTags.push(...valueTags);
                }
            });
        }
    }

    public getTagsFormattedForScaledResponse(questionId: string) {
        const tags = this.questionTags.get(questionId);
        return (
            tags?.map((value) => ({
                option: {
                    color: sentimentToColor(value.sentiment, value.scoredValue),
                    text: value.value,
                },
                data: value,
            })) ?? []
        );
    }

    public getTagsFormattedForTagResponse(questionId: string) {
        const tags = this.questionTags.get(questionId);
        return tags;
    }

    public getTagsFormattedForStarRating(questionId: string) {
        const tags = this.questionTags.get(questionId);
        return tags;
    }
}
